import { render, staticRenderFns } from "./InsertionNumber.vue?vue&type=template&id=993207ea&"
import script from "./InsertionNumber.vue?vue&type=script&lang=ts&"
export * from "./InsertionNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports